import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { rel } from '../../../../../../../../utils/rel';
import { formatDateTime2 } from '../../../../../../../../utils/timeUnit';
import { formatImage, formatUrl } from '@ifeng/public_method';

/**
 * 定义 RecommendList 组件
 */
class NewsLine extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const { thumbnails, url, title, source, newsTime, commentsNum = 0, commentUrl } = content;

        let picList = null;
        let titPic = null;

        if (thumbnails && thumbnails.image && thumbnails.image.length === 3) {
            picList = (
                <div className={styles.hg_img}>
                    <ul className="clearfix">
                        {thumbnails.image.map((each, index) => (
                            <li key={index}>
                                <a href={formatUrl(url)} target="_blank" rel={rel}>
                                    <LazyImg src={formatImage(each.url, 203, 130)} className={styles.trans} />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            );
        } else if (thumbnails && thumbnails.image && thumbnails.image.length === 1) {
            titPic = (
                <div className={styles.pic}>
                    <a href={formatUrl(url)} target="_blank" rel={rel}>
                        <LazyImg
                            src={formatImage(
                                thumbnails && thumbnails.image && thumbnails.image[0] && thumbnails.image[0].url,
                                170,
                                100,
                            )}
                            className={styles.trans}
                        />
                    </a>
                </div>
            );
        }

        return (
            <div
                className={`${styles.hg_box} ${
                    thumbnails && thumbnails.image && thumbnails.image.length !== 1 ? styles.hg_box_t : ''
                } ${thumbnails && thumbnails.image && thumbnails.image.length === 3 ? styles.hg_box_t2 : ''} clearfix`}>
                {titPic}
                <div className={styles.txt}>
                    <h5>
                        <a href={formatUrl(url)} target="_blank" rel={rel}>
                            {title}
                        </a>
                    </h5>
                </div>
                {picList}
                <div className={styles.txt}>
                    <div className={styles.hg_bom}>
                        <div className={styles.hg_sour}>
                            <span>{source}</span>
                            <span>{formatDateTime2(newsTime)}</span>
                        </div>
                        <div className={styles.hg_pl}>
                            <a href={formatUrl(commentUrl)} target="_blank" rel={rel}>
                                {commentsNum}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewsLine);
